import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './VendorLogin.css';

const VendorForgotPassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: 'contact@techsolutions.com',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
console.log("formData", formData)
// return false;
    try {
      let url = `${process.env.REACT_APP_API_URL}/api/v1/auth/forgot-password`
      const response = await axios.post(
        url,
        formData
      );

    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vendor-login-container">
      <div className="vendor-login-card">
        <div className="vendor-login-header">
          <h1>Forgot Password</h1>
          <p>Sign in to access your dashboard</p>
        </div>

        {error && (
          <div className="error-message">
            <i className="fas fa-exclamation-circle"></i>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="vendor-login-form">
          <div className="form-group">
            <label htmlFor="email">  
              <i className="fas fa-envelope" style={{"margin-right": "2%"}}></i>
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your.email@company.com"
              required
              disabled={loading}
            />
          </div>

      
          <button 
            type="submit" 
            className="vendor-login-button"
            disabled={loading}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                Sending...
              </>
            ) : (
              <>
                <i className="fas fa-sign-in-alt"></i>
                Forgot Password
              </>
            )}
          </button>
          
        </form>

        <div className="vendor-login-footer">
          <p>Already have account <a >Sign In</a></p>
          {/* <div className="test-credentials">
            <small>
              <strong>Test Credentials:</strong><br />
              Email: contact@techsolutions.com<br />
              Password: Vendor@123
            </small>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default VendorForgotPassword;


